// @flow

import * as React from 'react';
import { withHandlers } from 'recompose';
import glamorous from 'glamorous';
import Tappable from 'app/components/commons/Tappable';
import RewriteLink from 'app/components/routing/RewriteLink';
import { hover } from 'app/utils/cssUtils';

type Props = {
  children: React.Node,
  disabled?: boolean,
  onSelect?: () => void,
  selected: boolean,
  to?: string,
};

const defaultProps = {
  disabled: false,
  onSelect: undefined,
  to: undefined,
};

const LightTabDiv = glamorous('div')(
  ({ theme, selected }) => ({
    alignItems: 'center',
    backgroundColor: theme.color.panel,
    color: selected ? theme.color.panelSelected : theme.color.panelAccent,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: 50,
    justifyContent: 'flex-end',
    position: 'relative',
    textAlign: 'center',
    textTransform: 'uppercase',
    transition: 'all 0.2s',
  }),
  ({ disabled, theme }) => (
    disabled ? {
      cursor: 'not-allowed !important',
      opacity: 0.35,
    } : {
      ...hover({
        backgroundColor: theme.color.panelSecondary,
      }),
    }
  ),
);

const TextWrapper = glamorous.div({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
});

const TabLink = glamorous(RewriteLink)({
  color: 'inherit',
});

function LightTab({
  children,
  disabled,
  onSelect,
  selected,
  to,
}: Props) {
  if (to && !disabled) {
    return (
      <LightTabDiv selected={selected}>
        <TabLink to={to}>
          <TextWrapper>
            {children}
          </TextWrapper>
        </TabLink>
      </LightTabDiv>
    );
  }

  return (
    <Tappable
      component={LightTabDiv}
      disabled={disabled}
      onTap={onSelect}
      selected={selected}
    >
      <TextWrapper>
        {children}
      </TextWrapper>
    </Tappable>
  );
}

LightTab.defaultProps = defaultProps;

const enhancer = withHandlers({
  onSelect: ({ disabled, id, onSelect }) => () => {
    if (!onSelect) {
      return;
    }

    if (!disabled) {
      return;
    }

    onSelect(id);
  },
});

export default enhancer(LightTab);
